module.exports = window._;